import { PeluangApi } from "api"
import {
  ActionButton,
  Alert,
  BackButton,
  CRUDLayout,
  DataStatus,
  TBody,
  Td,
  TdFixed,
  TextArea,
  TextEditor,
  Th,
  ThFixed,
  Tr
} from "components"
import { ContentState, convertFromHTML, EditorState } from "draft-js"
import { Formik } from "formik"
import { useEffect, useState } from "react"
import { Card, Col, Modal, Row } from "react-bootstrap"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { DateConvert, DecimalConvert, GuestMiddleware } from "utilities"
import * as Yup from "yup"
import AnalisaBarangJadiPeluang from "./AnalisaBarangJadiPeluang"

const DetailPeluang = ({ setNavbarTitle }) => {
  const title = "Peluang"
  const history = useHistory()
  const { state } = useLocation()
  const { tab, no_peluang } = state || {}
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [isFetchingFailed, setIsFetchingFailed] = useState(false)
  const [approveStatus, setApproveStatus] = useState("V")
  const [dataApproval, setDataApproval] = useState([])
  const [data, setData] = useState([{ detail: [] }])
  const [dataBarangJadi, setDataBarangJadi] = useState([])
  const [processedData, setProcessedData] = useState({})
  const [modalConfig, setModalConfig] = useState({
    show: false,
    type: "",
    title: ""
  })
  const [modalAnalisaConfig, setModalAnalisaConfig] = useState({
    show: false,
    type: "",
    title: ""
  })
  const [showAlert, setShowAlert] = useState(false)
  const [alertConfig, setAlertConfig] = useState({
    variant: "primary",
    text: ""
  })
  const [textEditorState, setTextEditorState] = useState(() => {
    EditorState.createEmpty()
  })

  const getData = () => {
    setIsPageLoading(true)

    PeluangApi.getSingle({ no_peluang })
      .then((res) => {
        const behavior = String(res?.data?.data?.behavior).toUpperCase()

        setData(res?.data?.data ?? {})
        setDataApproval(res?.data?.data?.approval ?? [])
        setApproveStatus(behavior ?? "V")
      })
      .catch((err) => alert("Data gagal dimuat!"))
      .finally(() => setIsPageLoading(false))
  }

  // ON COMPONENT MOUNT
  useEffect(() => {
    setNavbarTitle("Detail " + title) // SET JUDUL NAVBAR
    getData() // GET DATA DARI SERVER
  }, [])

  useEffect(() => {
    setTextEditorState(
      EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML(data?.detail?.lain_lain ?? "<p></p>")
        )
      )
    )
  }, [data])

  const InfoSection = ({ data }) => {
    const InfoItem = ({ title, value }) => (
      <tr>
        <td>{title}</td>
        <td className="pl-4 pr-2">:</td>
        <td>{value}</td>
      </tr>
    )

    const ShowData = ({ title, text, line }) => (
      <div>
        <small
          className="text-secondary"
          style={{ opacity: 0.9, textTransform: "capitalize" }}>
          {title}
        </small>
        <div className="text-dark">
          <div>{text ? text : "-"}</div>
        </div>

        {line && <hr className="my-2" />}
      </div>
    )

    return (
      <>
        <Row className="mb-4">
          <Col>
            <table style={{ fontSize: "14px" }}>
              <tbody>
                <InfoItem
                  title="Tgl. Peluang"
                  value={
                    data?.tgl_peluang
                      ? DateConvert(new Date(data.tgl_peluang)).detail
                      : "-"
                  }
                />
                <InfoItem title="No. Peluang" value={data?.no_peluang ?? "-"} />
                <InfoItem
                  title="Peringkat Peluang"
                  value={data?.nama_peringkat_peluang ?? "-"}
                />
                <InfoItem title="ATT" value={data?.att ?? "-"} />
                <InfoItem
                  title="Unit Produksi"
                  value={data?.nama_unit_produksi ?? "-"}
                />
              </tbody>
            </table>
          </Col>
          <Col>
            <table style={{ fontSize: "14px" }}>
              <tbody>
                <InfoItem
                  title="Tgl. Info Peluang"
                  value={
                    data?.tgl_info_peluang
                      ? DateConvert(new Date(data.tgl_info_peluang)).detail
                      : "-"
                  }
                />
                <InfoItem
                  title="No. Info Peluang"
                  value={data?.no_info_peluang ?? "-"}
                />
                <InfoItem title="Customer" value={data?.nama_customer ?? "-"} />
                <InfoItem title="Proyek" value={data?.nama_proyek ?? "-"} />
              </tbody>
            </table>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md>
            <ShowData
              title="Keterangan Pengiriman"
              text={data.keterangan_pengiriman ?? "-"}
              line={true}
            />
          </Col>
          <Col md>
            <ShowData
              title="Lokasi Pengiriman"
              text={data.lokasi_pengiriman ?? "-"}
              line={true}
            />
          </Col>
        </Row>
        <TextEditor
          readOnly
          options={[]}
          label="Informasi Lainya"
          editorState={textEditorState}
        />
      </>
    )
  }

  const TableSection = ({ data }) => {
    return (
      <>
        <div className="my-2">
          <b>List Barang Jadi</b>
        </div>
        <CRUDLayout.Table>
          <thead className="bg-light">
            <Tr>
              <ThFixed>No</ThFixed>
              <Th style={{ width: 100 }}>Kode Barang Jadi</Th>
              <Th>Barang Jadi</Th>
              <Th>Jenis Barang Jadi</Th>
              <Th>Satuan</Th>
              <Th>Qty</Th>
            </Tr>
          </thead>
          <TBody>
            {data?.detail?.length > 0 ? (
              data?.detail?.map((val, index) => (
                <Tr key={index}>
                  <TdFixed>{index + 1}</TdFixed>
                  <TdFixed>{val.kode_item}</TdFixed>
                  <Td>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault()
                        setProcessedData({
                          ...val,
                          index: index,
                          id_barang_jadi: val.id_item_buaso
                        })
                        setModalAnalisaConfig({
                          show: true,
                          type: "analisa",
                          title: (
                            <span className="text-primary">
                              Analisa Barang Jadi Peluang
                            </span>
                          )
                        })
                      }}>
                      {val.nama_item}
                    </a>
                  </Td>
                  <Td>{val.nama_jenis ?? "-"}</Td>
                  <Td>{val.nama_satuan_jual ?? "-"}</Td>
                  <Td>
                    <div className="text-right">
                      {DecimalConvert(val.qty).getWithComa}
                    </div>
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <td colSpan="6" className="py-3 text-center">
                  <span style={{ fontSize: 14 }}>Tidak ada data</span>
                </td>
              </Tr>
            )}
          </TBody>
        </CRUDLayout.Table>
      </>
    )
  }

  const ModalAnalisaSection = ({
    processedData,
    modalConfig,
    setModalConfig
  }) => {
    return (
      <Modal
        scrollable={true}
        show={modalConfig.show}
        size={modalConfig.type === "analisa" ? "xl" : "md"}
        onHide={() => setModalConfig({ ...modalConfig, show: false })}>
        <Modal.Header closeButton className="py-2">
          <Modal.Title>
            <small>{modalConfig.title}</small>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AnalisaBarangJadiPeluang processedData={processedData} />
        </Modal.Body>
      </Modal>
    )
  }

  const ModalSection = ({ values, isSubmitting, handleSubmit }) => {
    const ModalContent = () => (
      <>
        <Modal.Body className="text-center">
          <h6>
            <b>
              {modalConfig.title === "aprove"
                ? approveStatus === "A"
                  ? "Approve"
                  : "Verify"
                : modalConfig.title}{" "}
              dengan catatan :
            </b>
          </h6>
          <span>{values.catatan}</span>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <ActionButton
            variant="outline-secondary"
            text="Batal"
            className="px-4"
            onClick={() =>
              setModalConfig({
                ...modalConfig,
                show: false
              })
            }
          />
          <ActionButton
            text={
              modalConfig.type === "APP"
                ? "Approve"
                : modalConfig.type === "VER"
                ? "Verify"
                : modalConfig.type === "REJ"
                ? "Reject"
                : "Revise"
            }
            variant={
              modalConfig.type === "APP"
                ? "success"
                : modalConfig.type === "VER"
                ? "success"
                : modalConfig.type === "REV"
                ? "warning"
                : "danger"
            }
            className="m-1 px-3 text-white"
            onClick={handleSubmit}
            loading={isSubmitting}
          />
        </Modal.Footer>
      </>
    )

    return (
      <Modal
        show={modalConfig.show}
        onHide={() =>
          setModalConfig({
            ...modalConfig,
            show: false
          })
        }>
        <Modal.Header closeButton className="py-2 d-flex align-items-center">
          <Modal.Title>
            <small>{modalConfig.title}</small>
          </Modal.Title>
        </Modal.Header>
        <ModalContent />
      </Modal>
    )
  }

  const FormCard = ({
    values,
    handleChange,
    validateForm,
    errors,
    touched,
    setTouched,
    dirty
  }) => {
    const InfoItem = ({ title1, value1, title2, value2 }) => (
      <div className="col-md-4 mb-4">
        <small>{title1}</small>
        <br />
        <b>{value1}</b>
        <div className="mt-1" />
        <small>{title2}</small>
        <br />
        <b>{value2}</b>
      </div>
    )

    return (
      <Card className="mt-4 mb-5">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <b>Approval Peluang</b>
        </Card.Header>
        <Card.Body>
          <div className="d-flex align-content-between flex-wrap">
            {dataApproval.map((val, index) => (
              <InfoItem
                key={index}
                title1={
                  val.status_approval == "VER"
                    ? `PEMERIKSA ${val.approval_level}`
                    : "PENGESAH"
                }
                value1={val.nama_karyawan ?? "-"}
                title2={"Catatan"}
                value2={val.catatan ?? "-"}
              />
            ))}
          </div>
          <hr />
          <div>
            <TextArea
              label="Catatan"
              name="catatan"
              placeholder="Masukan catatan"
              value={values.catatan}
              onChange={handleChange}
              error={errors.catatan && true}
              errorText={errors.catatan}
            />
            <div className="d-flex justify-content-end mt-3">
              <ActionButton
                text="Reject"
                variant="danger"
                className="m-1"
                onClick={() => {
                  if (dirty) {
                    setModalConfig({
                      show: true,
                      type: "REJ",
                      title: <span className="text-danger">Reject Peluang</span>
                    })
                  }
                  validateForm()
                }}
              />

              {approveStatus !== "A" && (
                <ActionButton
                  text="Revise"
                  variant="warning"
                  className="m-1 text-white"
                  onClick={() => {
                    if (dirty) {
                      setModalConfig({
                        show: true,
                        type: "REV",
                        title: (
                          <span className="text-warning">Revise Peluang</span>
                        )
                      })
                    }
                    validateForm()
                  }}
                />
              )}

              <ActionButton
                text={approveStatus === "A" ? "Approve" : "Verify"}
                variant="success"
                className="m-1"
                onClick={() => {
                  if (dirty) {
                    setModalConfig({
                      show: true,
                      type: "APP",
                      title: (
                        <span className="text-success">Approve Peluang</span>
                      )
                    })
                  }
                  validateForm()
                }}
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    )
  }

  const CatatanApproval = () => {
    const InfoItem = ({ title1, value1, title2, value2 }) => (
      <div className="mb-2">
        <small>{title1}</small>
        <br />
        <b>{value1}</b>
        <div className="mt-1" />
        <small>{title2}</small>
        <br />
        <b>{value2}</b>
      </div>
    )

    return (
      <Card className="mt-4 mb-5">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <b>Catatan Approval Peluang</b>
        </Card.Header>
        <Card.Body>
          <Row>
            {data?.detail?.stakeholder?.map(
              (val, index) =>
                index !== 0 &&
                val.status_approval !== "PEN" && (
                  <Col sm>
                    <InfoItem
                      title1={
                        val.status_approval === "VER" ||
                        val.status_approval === "REV"
                          ? `Pemeriksa ${
                              val.approval_level !== "0"
                                ? val.approval_level
                                : ""
                            }`
                          : val.status_approval === "APP"
                          ? "Pengesah"
                          : "Di Tolak Oleh"
                      }
                      value1={val.nama_karyawan ?? "-"}
                      title2="Catatan"
                      value2={val.catatan ?? "-"}
                    />
                  </Col>
                )
            )}
          </Row>
        </Card.Body>
      </Card>
    )
  }

  return (
    <CRUDLayout>
      {/* Alert */}
      <Alert
        show={showAlert}
        showCloseButton={true}
        variant={alertConfig.variant}
        text={alertConfig.text}
        onClose={() => setShowAlert(false)}
      />

      <Card className="pb-3 mt-3">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <b>Detail Data {title}</b>
          <BackButton size="sm" onClick={() => history.goBack()} />
        </Card.Header>
        <Card.Body>
          {isPageLoading ? (
            <DataStatus loading={isPageLoading} text="Memuat Data" />
          ) : (
            <>
              <InfoSection data={data?.detail} />
              <hr />
              <TableSection data={data?.detail} />
            </>
          )}
        </Card.Body>
      </Card>

      <ModalAnalisaSection
        processedData={processedData}
        dataBarangJadi={dataBarangJadi}
        setDataBarangJadi={setDataBarangJadi}
        alertConfig={alertConfig}
        setAlertConfig={setAlertConfig}
        modalConfig={modalAnalisaConfig}
        setModalConfig={setModalAnalisaConfig}
      />

      {!isFetchingFailed && !isPageLoading && tab !== "history" && (
        <Formik
          initialValues={{ catatan: "" }}
          validationSchema={Yup.object().shape({
            catatan: Yup.string().required("Masukan Catatan")
          })}
          onSubmit={(values, { setSubmitting }) => {
            const finalValues = {
              ...values,
              no_transaksi: data?.detail?.no_peluang,
              status_approval: modalConfig.type,
              tgl_approval: DateConvert(new Date()).default,
              approval_baseline: data?.detail?.baseline
            }

            PeluangApi.approve(finalValues)
              .then((res) => {
                history.push("/human-resource/approval/peluang", {
                  alert: {
                    show: true,
                    variant: "primary",
                    text: `${
                      modalConfig.type == "APP"
                        ? "Approve"
                        : modalConfig.type == "REV"
                        ? "Revise"
                        : modalConfig.type === "VER"
                        ? "Verify"
                        : "Reject"
                    } data berhasil!`
                  }
                })

                const logValues = {
                  no_transaksi: data.no_rae,
                  nama_transaksi: "Peluang",
                  baseline: data.baseline,
                  status_approval: modalConfig.type,
                  no_transaksi_ref: data.no_peluang,
                  baseline_ref: data.baseline,
                  keterangan_transaksi:
                    modalConfig.type === "APP"
                      ? "Approve Peluang"
                      : modalConfig.type === "VER"
                      ? "Verifikasi Peluang"
                      : "Reject Peluang"
                }
                // PeluangApi.saveLogProgess(logValues);
              })
              .catch((err) => {
                setAlertConfig({
                  show: true,
                  variant: "danger",
                  text: `Simpan approval gagal! (${
                    err?.response?.data?.message ?? ""
                  })`
                })
              })
              .finally(() => setModalConfig({ show: false }))
          }}>
          {({
            values,
            isSubmitting,
            handleChange,
            handleSubmit,
            errors,
            touched,
            validateForm,
            dirty
          }) => (
            <>
              <GuestMiddleware>
                <FormCard
                  values={values}
                  handleChange={handleChange}
                  errors={errors}
                  touched={touched}
                  validateForm={validateForm}
                  dirty={dirty}
                />
              </GuestMiddleware>
              <ModalSection
                values={values}
                isSubmitting={isSubmitting}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
              />
            </>
          )}
        </Formik>
      )}

      {!isFetchingFailed && !isPageLoading && tab === "history" && (
        <CatatanApproval />
      )}
    </CRUDLayout>
  )
}
export default DetailPeluang
